import React, { useState } from 'react';
import { CURRENCY_SYMBOLS } from '../../../../utils/constants/currency-symbols';
import Button from '../../../../shared/button';
import Table from '../../../../shared/table';
import Input from '../../../../shared/input';


interface IFormPurchaseItemsTable {
    allRowsData?: any;
    allRowsItems?: any;
    filterErrors?: any;
    currency?: string
    onChangeInputValue: (e: any, type?: string, index?: any) => void;
    onClickAddRow: () => void;
    onDeleteItemRow: (id: any) => void;
    onCloneRow: (id: any) => void;
}

const FormPurchaseItemsTable = ({
    allRowsItems,
    allRowsData,
    filterErrors,
    currency,
    onClickAddRow,
    onChangeInputValue,
    onDeleteItemRow,
    onCloneRow,
}: IFormPurchaseItemsTable) => {
    const [tableColumns] = useState<Array<string>>(['Item Name', 'Price', 'Quantity', 'Subtotal', 'Actions']);
    const allRowsDataClone = [...(allRowsData || [])];

    let findTotalQuantity = 0;
    let subPriceTotal = 0;

    allRowsData && allRowsData?.length > 0 &&
        [...allRowsData].map((currentValue: any) => {
            subPriceTotal = subPriceTotal + Number(currentValue.price || 0) * Number(currentValue?.qty || 0);
            findTotalQuantity = Number(findTotalQuantity) + Number(currentValue?.qty || 0);
            return currentValue;
        });

    return (
        <Table
            columns={tableColumns || []}
            containerStyle={'min-h-[300px] relative bg-white pb-10 border border-2'}
            hidePagination={true}
        >
            <>
                {[...Array(allRowsDataClone?.length || 1)].map((x, i) => {
                    const findValue = allRowsDataClone && allRowsDataClone?.length > 0 && allRowsDataClone?.find((data: any, idx: number) => idx === i);
                    const findErrorRow = filterErrors && filterErrors?.length > 0 && filterErrors?.find((error: any, idx: number) => error?.index === i);
                    // const isLoading = itemsLoading && (itemsLoading?.row === i)
                    return (
                        <tr key={i} className='bg-white'>
                            <td className='px-2 py-2 min-w-[200px]'>
                                <Input
                                    containerStyle={'w-full'}
                                    placeholder={'Item Name'}
                                    inputUniqueName={'itemName'}
                                    onChangeInput={onChangeInputValue}
                                    inputValue={findValue?.itemName}
                                    showValue={true}
                                    index={i}
                                    error={findErrorRow?.itemName}
                                />
                            </td>
                            <td className='px-2 py-2 min-w-[130px]'>
                                <Input
                                    containerStyle={'w-full'}
                                    placeholder={'Price'}
                                    inputUniqueName={'price'}
                                    onChangeInput={onChangeInputValue}
                                    inputValue={findValue?.price}
                                    showValue={true}
                                    index={i}
                                    error={findErrorRow?.price}
                                />
                            </td>
                            <td className='px-2 py-2 min-w-[130px]'>
                                <Input
                                    containerStyle={'w-full'}
                                    placeholder={'Qty'}
                                    inputUniqueName={'qty'}
                                    onChangeInput={onChangeInputValue}
                                    inputValue={findValue?.qty}
                                    showValue={true}
                                    index={i}
                                    error={findErrorRow?.qty}
                                />
                            </td>
                            <td className='px-4 pb-4 pt-2'>
                                {CURRENCY_SYMBOLS[`${(currency || '')}`]}{(Number(findValue?.price || 0) * Number(findValue?.qty || 0)).toFixed(2)}
                            </td>
                            <td className='px-2 min-w-[100px]'>
                                <div className='flex flex-row items-center'>
                                    <div onClick={() => onDeleteItemRow(i)}>
                                        <img title={'Delete Row'} alt='delete item' src={'/assets/table-actions/delete-close.svg'} className={'h-[12px] object-contain cursor-pointer mr-3'} />
                                    </div>
                                    <div onClick={() => onCloneRow(i)}>
                                        <img title={'Clone Row'} alt='clone item' src={'/assets/table-actions/clone.svg'} className={'h-[25px] object-contain cursor-pointer mr-1'} />
                                    </div>
                                </div>
                            </td>
                        </tr>
                    );
                })}
                <tr className='bg-white 1'>
                    <td className='px-2 py-2'>
                        <Button
                            label='Add Item'
                            onClickButton={() => onClickAddRow()} />
                    </td>
                    <td className='px-2 py-2 text-end' colSpan={4}>
                        <span className='ml-2 mr-1'>| Quantity: <span className='text-primary-default'>{findTotalQuantity}</span></span>
                        <span className='mr-2'>| Subtotal: <span className='text-primary-default'>
                            {CURRENCY_SYMBOLS[`${(currency || '')}`]}{Number(subPriceTotal || 0).toFixed(2)}
                        </span>
                        </span>
                    </td>
                </tr>
            </>
        </Table>
    );
};

export default FormPurchaseItemsTable;
